module.exports = __webpack_public_path__ + "img/drum.4528bcd3.gif";